import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import RichText from 'src/siteBuilder/blocks/core/RichText/RichText'
import PepOffers, { PepOffersProps } from './pepOffers'
import type { Document } from '@contentful/rich-text-types'

interface PepOffersContentfulFields {
  entryTitle?: string
  iconName?: string
  offerText?: Document
  showTooltip?: boolean
  tooltipInfoText?: string
}

const ContentfulPepOffers = withContentful<PepOffersContentfulFields, PepOffersProps>(PepOffers, {
  iconName: (props) => props.fields.iconName,
  offerText: (props) =>
    props.fields.offerText ? (
      <RichText richText={props.fields.offerText} colour="brand" paragraphSize="small" />
    ) : undefined,
  showTooltip: (props) => props.fields.showTooltip,
  tooltipInfoText: (props) => props.fields.tooltipInfoText,
})

export default ContentfulPepOffers
